import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'iho-accommodation-facilities-filter',
  templateUrl: './accommodation-facilities.component.html',
  styleUrls: ['./accommodation-facilities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule, MatCheckboxModule],
})
export class AccommodationFacilitiesComponent implements OnInit {
  @Input() dataSource?: any[];
  @Output() checkedItemsEmit = new EventEmitter();
  itemsPush: string[] = [];

  route = inject(ActivatedRoute);
  router = inject(Router);

  ngOnInit(): void {
    const params: any = this.route.snapshot.queryParams;
    const listParams = params.facilities?.length > 1
      ? params.facilities.split(',')
      : params.facilities?.split();

    if (params.facilities && this.dataSource) {
      this.dataSource = this.dataSource.map((item: any) => ({
        ...item,
        checked: listParams.includes(item.Value),
      }));
      this.itemsPush = this.dataSource
        .filter(item => item.checked)
        .map(item => item.Value);
    } else if (this.dataSource) {
      this.dataSource = this.dataSource.map((item: any) => ({
        ...item,
        checked: false,
      }));
    }
  }

  changeSelected(val: string, ev: any) {
    if (!this.dataSource) return;

    // ساخت نسخه جدید از dataSource با مقدار checked بروز شده
    this.dataSource = this.dataSource.map(item => {
      if (item.Value === val) {
        return { ...item, checked: ev.checked };
      }
      return item;
    });

    // بروزرسانی itemsPush
    if (ev.checked && !this.itemsPush.includes(val)) {
      this.itemsPush.push(val);
    } else if (!ev.checked && this.itemsPush.includes(val)) {
      this.itemsPush = this.itemsPush.filter(v => v !== val);
    }

    this.checkedItemsEmit.emit({
      value: this.itemsPush,
      ev,
      key: 'facilities',
    });
  }
}
